import { render, staticRenderFns } from "./index.vue?vue&type=template&id=02bcdf58"
import script from "./vendorDashboard.js?vue&type=script&lang=js&external"
export * from "./vendorDashboard.js?vue&type=script&lang=js&external"
import style0 from "./vendorDashboard.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports